//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixin from '@/mixins'
import upDialog from './components/Dialog.vue'
import indexFooter from './components/indexFooter'
import { MainApi } from '@/api'
import testDialog from './components/testDialog.vue'
import Util from '@/common/js/util'

export default {
  name: 'addPlan',
  mixins: [mixin],
  components: {
    indexFooter,
    upDialog,
    testDialog,
  },
  data() {
    return {
      form: {
        AnnualIncome: 20,
        MonthlyDeposit: 1000,
        TargetDuration: 3,
      },
      isRuleShows: false,
      isTestResShows: false,
      overTag: '',
      tagName: '',
      id: '',
    }
  },
  created() {},
  mounted() {},

  methods: {
    nextBtnFn() {
      const regNum = /^[1-9]\d*$/
      if (!regNum.test(this.form.AnnualIncome)) {
        this.$vux.toast.show({
          type: 'warn',
          text: '请输入正整数年收入',
        })
        return false
      }
      // console.log('this.form.AnnualIncome', this.form.AnnualIncome)

      if (this.form.AnnualIncome < 3) {
        this.$vux.toast.show({
          type: 'warn',
          text: '您的固定年收入最低为3万元',
        })
        return false
      }

      if (!regNum.test(this.form.MonthlyDeposit)) {
        this.$vux.toast.show({
          type: 'warn',
          text: '请输入正整数每月存款金额',
        })
        return false
      }

      if (this.form.MonthlyDeposit < 500) {
        this.$vux.toast.show({
          type: 'warn',
          text: '每月存款金额必须大于等于500元',
        })
        return false
      }
      // console.log('this.form.TargetDuration', this.form.TargetDuration)

      // if (this.form.TargetDuration < 1) {
      //   this.$vux.toast.show({
      //     type: 'warn',
      //     text: '您的目标存款期限最低为1年',
      //   })
      //   return false
      // }

      if (!regNum.test(this.form.TargetDuration)) {
        this.$vux.toast.show({
          type: 'warn',
          text: '请输入正整数目标存款期限',
        })
        return false
      }
      if (this.form.TargetDuration < 1) {
        this.$vux.toast.show({
          type: 'warn',
          text: '存款期限最少为1年',
        })
        return false
      }
      if (this.form.TargetDuration > 15) {
        this.$vux.toast.show({
          type: 'warn',
          text: '存款期限最多15年（包含）',
        })
        return false
      }

      this.$vux.loading.show({
        text: '加载中',
      })

      MainApi.addUserDepositPlan(this.form)
        .then(data => {
          // this.$vux.loading.hide()
          if (data.Status === 200) {
            console.log('data', data)
            this.id = data.Result.id
            if (this.getArchives) {
              // this.tagName = Util.getTagArrFn()[this.getArchives - 1]
              // console.log('this.id', this.id, data.Result.id)

              // this.isTestResShows = true
              // this.$router.push('myPlan')
              MainApi.getUserDepositPlanCompute({
                id: this.id,
              })
                .then(data => {
                  if (data.Status === 200) {
                    this.$vux.loading.hide()
                    this.$router.push({
                      path: 'planResult',
                      query: { id: this.id },
                    })
                  } else {
                    this.$vux.loading.hide()
                    this.$vux.toast.text(data.Result.ErrorMsg, 'top')
                  }
                })
                .catch(() => {
                  this.$vux.loading.hide()
                })
            } else {
              this.$vux.loading.hide()
              this.$router.push({
                path: 'riskTest',
                query: { id: this.id },
              })
            }
          } else {
            this.$vux.toast.text(data.Result.ErrorMsg, 'top')
          }
        })
        .catch(() => {
          this.$vux.loading.hide()
        })
    },
    lookRuleFn() {
      console.log('name')

      this.isRuleShows = true
    },
    getChangeCloseFn() {
      this.isRuleShows = false
    },
    goToHome() {
      this.$router.push('myPlan')
    },
    enterInputFn(idx) {
      if (idx) {
        this.$refs['input' + idx].focus()
      }
    },
    getInputFocusFn(idx) {
      switch (idx) {
        case 1:
          this.form.AnnualIncome = ''
          break
        case 2:
          this.form.MonthlyDeposit = ''
          break
        default:
          this.form.TargetDuration = ''
          break
      }
    },
  },
  computed: {
    getArchives() {
      return this.$store.state.Archives
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/addPlan.vue